import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import analytics from '../services/analytics';

// Hook for automatic page view tracking
export const usePageTracking = () => {
  const location = useLocation();
  const { user } = useAuth();

  useEffect(() => {
    // Track page view
    analytics.trackPageView(location.pathname);
    
    // Identify user if logged in
    if (user) {
      const userType = user.is_admin ? 'admin' : user.is_buyer ? 'buyer' : 'seller';
      analytics.identifyUser(user.id.toString(), userType, user.email_verified);
    }
  }, [location, user]);
};

// Hook for business event tracking
export const useAnalytics = () => {
  return {
    // User events
    trackUserRegistration: analytics.trackUserRegistration.bind(analytics),
    trackUserLogin: analytics.trackUserLogin.bind(analytics),
    trackEmailVerification: analytics.trackEmailVerification.bind(analytics),
    
    // Business events
    trackInvoiceUpload: analytics.trackInvoiceUpload.bind(analytics),
    trackInvoiceVerification: analytics.trackInvoiceVerification.bind(analytics),
    trackBidPlaced: analytics.trackBidPlaced.bind(analytics),
    trackBidAccepted: analytics.trackBidAccepted.bind(analytics),
    trackBidRejected: analytics.trackBidRejected.bind(analytics),
    trackTransaction: analytics.trackTransaction.bind(analytics),
    
    // User behavior
    trackMarketplaceView: analytics.trackMarketplaceView.bind(analytics),
    trackInvoiceDetailView: analytics.trackInvoiceDetailView.bind(analytics),
    trackSearch: analytics.trackSearch.bind(analytics),
    
    // Forms
    trackFormStart: analytics.trackFormStart.bind(analytics),
    trackFormSubmit: analytics.trackFormSubmit.bind(analytics),
    trackFormError: analytics.trackFormError.bind(analytics),
    
    // Files
    trackFileUpload: analytics.trackFileUpload.bind(analytics),
    
    // Errors
    trackError: analytics.trackError.bind(analytics),
    trackApiError: analytics.trackApiError.bind(analytics),
    
    // Conversion funnel
    trackFunnelStep: analytics.trackFunnelStep.bind(analytics),
    
    // Generic event tracking
    trackEvent: analytics.trackEvent.bind(analytics)
  };
};

export default analytics;